import { Play } from 'lucide-react';

import { Button } from '../ui/button';

interface TriggerTourProps {
  onStartTour: () => void;
  className?: string;
}

export function TriggerTour({ onStartTour, className }: TriggerTourProps) {
  return (
    <Button
      onClick={onStartTour}
      className={`gap-2 bg-brand-300 text-white ${className || ''}`}
    >
      <Play className="h-4 w-4" />
      Tour
    </Button>
  );
}
